import axios from "axios";
import apiURI from "./Api";

export default class ShippingService {
  async getQuoteShipping(orderId, token) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/shipping/quoteshipping/${orderId}`,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }

  async getLabel(orderId, token) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/shipping/getlabel/${orderId}`,
      responseType: "arraybuffer",
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }

  async getQuoteShippingProduct(weight, countryfrom) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/shipping/quoteshippingproduct/weight/${weight}/countryfrom/${countryfrom}`,
      headers: { Authorization: "Bearer " + localStorage.getItem("__extraconomy_token") },
    });

    return response.data;
  }

  async postCreatePickup(from, until, orderId, username, token) {
    const bodyJson = {
      from,
      orderid: orderId,
      seller: { username },
      until,
    };

    const response = await axios({
      method: "post",
      url: `${apiURI}/shipping/pickup/create`,
      data: bodyJson,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }

  async getParcelInfo(orderId, token) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/shipping/getparcel/${orderId}`,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }
}
